module.exports = __webpack_public_path__ + "c8ffdeb3144d5055756ef01ef98e8486.woff";


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/themes/fonts/OpenSans-Regular-webfont.woff
// module id = 2517
// module chunks = 17